export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 6 L52 19 V57 H12 V19 Z" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M32 11 L33.6 16.4 L39 18 L33.6 19.6 L32 25 L30.4 19.6 L25 18 L30.4 16.4 Z" fill="currentColor" />
    <path d="M19 38 Q32 26 45 38 Q32 50 19 38 Z" fill="none" stroke="currentColor" strokeWidth="2.5" />
    <circle cx="32" cy="38" r="4.5" fill="currentColor" />
  </svg>
);

export const Logo = () => (
  <a href="/" data-testid="brand-logo" className="flex items-center gap-3 text-[var(--gold)]">
    <LogoMark />
    <span className="font-display text-2xl leading-none tracking-tight text-[#F5F2EB]">
      Mãos <em className="text-[var(--gold)]">Arcana</em>
    </span>
  </a>
);
